<template>
  <div
    class="px-15"
  >
    <v-row transition="scale-transition">
      <v-col cols="12" sm="12" md="12" lg="12" class="d-flex align-center justify-center">
        <v-img
          src="@/assets/qrcode/qrcode-raplatform.jpg"
          alt="addfriend"
          aspect-ratio="1"
          width="250"
          height="250"
          contain
        />
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="12" class="d-flex flex-column align-center justify-center">
        <span class="title-qrcode-raplatform">เพิ่มเพื่อนใน OneChat ด้วยคิวอาร์โค้ด</span>
        <span class="label-qrcode-raplatform">เปิดแอพ OneChat > เลือกแท็บหน้าหลัก > แล้วเลือก "สแกนคิวอาร์โค้ด" จากนั้นจึงสแกนคิวอาร์โค้ด</span>
        <span class="label-qrcode-raplatform">หรือ เปิดแอพ OneChat > เลือกแท็บหน้าหลัก > แตะไอคอนเพิ่มเพื่อน แล้วค้นหา "น้อง RA Platform" จากนั้นกดเพิ่มเพื่อน</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" class="d-flex align-center justify-center">
        <v-btn @click="goback" color="primary" width="100px">
          กลับ
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {

  data: () => ({
  }),
  methods: {
    goback () {
      this.$router.push(localStorage.mainpage || '')
    }
  }
}

</script>
